import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export default function FusionPledgeSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const slug = params.get("slug");
  const [state, setState] = useState("checking");
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/fusion/public/pledge/status/${sessionId}`);
        if (data.status === "paid") { setAmount(data.amount_usd); setState("paid"); return; }
      } catch { setState("error"); return; }
      if (++tries < 8) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#080e1c] flex items-center justify-center px-5">
      <div className="max-w-md w-full rounded-3xl border border-white/10 bg-white/5 p-8 text-center" data-testid="pledge-success-card">
        {state === "checking" && <div className="text-white/60 animate-pulse">Confirming your donation…</div>}
        {state === "paid" && (
          <>
            <CheckCircle2 className="h-14 w-14 mx-auto text-emerald-400" />
            <h1 className="text-2xl font-black text-white mt-4">Thank you!</h1>
            <p className="text-sm text-white/60 mt-2">Your donation{amount ? ` of $${amount.toFixed(2)}` : ""} was received. A confirmation email is on its way.</p>
          </>
        )}
        {(state === "timeout" || state === "error") && (
          <p className="text-sm text-white/60">We couldn't confirm the payment yet — if you completed checkout, your donation will appear on the campaign shortly.</p>
        )}
        {slug && (
          <Link to={`/fusion/a/${slug}`} className="inline-block mt-6 px-6 py-3 rounded-full font-black text-sm bg-cyan-400 text-[#0b1424]" data-testid="back-to-campaign-btn">
            Back to the campaign
          </Link>
        )}
      </div>
    </div>
  );
}
